import { Checkbox, message, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useState } from "react";
import { useAuth } from "../../Contexts/AuthContext";
import { formatDateRangeWithDateString } from "../../Helpers/DateHelpers";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { EventService } from "../../Services/EventService";
import { TextService } from "../../Services/TextService";
import { EventType } from "../../Types/EventType";

/**
 * Closes an event for more replies, with a message that can be sent to those who replied. A poll is
 * closed by choosing its final time (`chosenTime`), a sign-up has no time to choose.
 */
export const CloseEventModal = (props: { event: any, open: boolean, chosenTime?: any, onCancel: () => void, onClosed: (chosenTime?: any) => void }) => {
    const GetText = TextService.GetText;
    const { user } = useAuth();
    const [closeMessage, setCloseMessage] = useState("");
    // Whether those who replied get the message by e-mail when the event is closed.
    const [sendCloseEmail, setSendCloseEmail] = useState(true);
    const isPoll = props.event.eventType === EventType.Poll;
    const signature = user?.firstName + " " + user?.lastName;

    // A new default message each time the modal is opened, since the chosen time may differ.
    useEffect(() => {
        if (!props.open) {
            return;
        }

        setSendCloseEmail(true);
        setCloseMessage(props.chosenTime
            ? GetText("ReplyTable_EventClosedDefaultText1") + props.event.eventName + GetText("ReplyTable_EventClosedDefaultText2") + formatDateRangeWithDateString(props.chosenTime.start, props.chosenTime.end, props.chosenTime.isFullDay, getCurrentLanguage() == "se") + GetText("ReplyTable_EventClosedDefaultText3") + signature
            : GetText("ReplyTable_SignUpClosedDefaultText1") + props.event.eventName + GetText("ReplyTable_SignUpClosedDefaultText2") + signature);
    }, [props.open, props.chosenTime]);

    const handleOk = async () => {
        const htmlMessage = closeMessage.replace("\r", "<br>");
        await EventService.CloseEvent(props.event.eventId, sendCloseEmail ? htmlMessage : "", sendCloseEmail);
        message.success(GetText("ReplyTable_EventHasBeenClosed"));
        props.onClosed(props.chosenTime);
    };

    return <Modal
        title={GetText(isPoll ? "ReplyTable_ClosePollTitle" : "ReplyTable_CloseSignUp")}
        open={props.open}
        okText={GetText(isPoll ? "ReplyTable_ClosePollTitle" : "ReplyTable_CloseSignUp")}
        cancelText={GetText("Common_Cancel")}
        onOk={handleOk}
        onCancel={props.onCancel}
    >
        <p><i>{GetText(isPoll ? "ReplyTable_CloseEventModalDescription" : "ReplyTable_CloseSignUpModalDescription")}</i></p>
        <Checkbox checked={sendCloseEmail} onChange={(e) => setSendCloseEmail(e.target.checked)} style={{ marginBottom: "8px" }}>
            {GetText("ReplyTable_CloseSendEmail")}
        </Checkbox>
        {/* The message is only needed when it is sent. */}
        {sendCloseEmail ?
            <TextArea rows={6} value={closeMessage} onChange={(e) => setCloseMessage(e.target.value)} style={{ width: "100%" }} /> : ""}
    </Modal>;
};
